/**
 * The history tabs of a customer page (`/users/$userId`), in the strip's order. The tab rides the
 * URL (`?tab=`), so a tab is a link. The Shopify tab is a Shopify customer's alone; the two
 * screening tabs keep short labels so the strip fits on one line.
 */
export const USER_TABS = [
  "purchases",
  "ledger",
  "opens",
  "inventory",
  "orders",
  "battles",
  "fraud",
  "kyc",
  "shopify",
] as const;
export type UserTab = (typeof USER_TABS)[number];

export const USER_TAB_LABELS: Record<UserTab, string> = {
  purchases: "Purchases",
  ledger: "Ledger",
  opens: "Opens",
  inventory: "Inventory",
  orders: "Orders",
  battles: "Battles",
  fraud: "Fraud",
  kyc: "Identity",
  shopify: "Shopify",
};

export function isUserTab(value: unknown): value is UserTab {
  return typeof value === "string" && (USER_TABS as readonly string[]).includes(value);
}

export interface UserSearch {
  tab?: UserTab;
}

/** The route's `validateSearch`: an unknown tab is dropped, and the page shows its first. */
export function parseUserSearch(search: Record<string, unknown>): UserSearch {
  return { tab: isUserTab(search.tab) ? search.tab : undefined };
}

/** The tabs this user has, in the strip's order. */
export function visibleUserTabs(isShopifyCustomer: boolean): readonly UserTab[] {
  return isShopifyCustomer ? USER_TABS : USER_TABS.filter((tab) => tab !== "shopify");
}

/** The tab to show: the requested one when this user has it, else Purchases. */
export function resolveUserTab(
  requested: UserTab | undefined,
  isShopifyCustomer: boolean,
): UserTab {
  if (requested && visibleUserTabs(isShopifyCustomer).includes(requested)) return requested;
  return "purchases";
}
